(function () {
  const CONFIG_URL = "https://configuratore-ui.vercel.app/";
  const OVERLAY_ID = "nabeConfiguratorOverlay";
  const IFRAME_ID = "nabeConfiguratorIframe";
  const LOADING_ID = "nabeConfiguratorLoading";

  let lastScrollTop = 0;
  let currentQuestion = null;
  let isChatReady = false;
  let isIframeLoaded = false;

  const getOverlay = () => document.getElementById(OVERLAY_ID);
  const getIframe = () => document.getElementById(IFRAME_ID);
  const getLoading = () => document.getElementById(LOADING_ID);

  const getIframeOrigin = (iframe) => {
    const fallback = new URL(CONFIG_URL, window.location.href).origin;
    if (!iframe) return fallback;
    const src = iframe.getAttribute("src") || CONFIG_URL;
    try {
      return new URL(src, window.location.href).origin;
    } catch (err) {
      console.warn("[Nabè configuratore] Impossibile calcolare origin iframe:", err);
      return fallback;
    }
  };

  const sendPendingQuestion = () => {
    if (!currentQuestion || !isChatReady) return;
    const iframe = getIframe();
    if (!iframe || !iframe.contentWindow) {
      console.warn(
        "[Nabè configuratore] Iframe non trovato, impossibile inviare la domanda.",
      );
      return;
    }
    const origin = getIframeOrigin(iframe);
    iframe.contentWindow.postMessage(
      { type: "NABE_PREFILL_QUESTION", text: currentQuestion },
      origin,
    );
    currentQuestion = null;
  };

  const loadIframeIfNeeded = () => {
    const iframe = getIframe();
    if (!iframe || isIframeLoaded) return;

    console.log("[Nabè configuratore] Caricamento iframe...");
    iframe.src = CONFIG_URL;
    isIframeLoaded = true;

    iframe.onload = () => {
      const loading = getLoading();
      if (loading) loading.style.display = "none";
      iframe.style.display = "block";
      console.log("[Nabè configuratore] Iframe caricato");
    };
  };

  // ============================================================
  // CARICA IFRAME CON CONFIG ID (per auto-open da link condiviso)
  // Passa il ?config=UUID direttamente nella URL dell'iframe
  // ============================================================
  const loadIframeWithConfig = (configId) => {
    const iframe = getIframe();
    if (!iframe) return;

    const configUrl = CONFIG_URL + "?config=" + encodeURIComponent(configId);
    console.log("[Nabè configuratore] Caricamento con config:", configId);
    iframe.src = configUrl;
    isIframeLoaded = true;

    iframe.onload = () => {
      const loading = getLoading();
      if (loading) loading.style.display = "none";
      iframe.style.display = "block";
      console.log("[Nabè configuratore] Iframe caricato con configurazione salvata");
    };
  };

  const openConfiguratorOverlay = (triggeredByQuickQuestion) => {
    const overlay = getOverlay();
    const iframe = getIframe();
    const loading = getLoading();

    if (!overlay || !iframe) {
      console.warn("[Nabè configuratore] Overlay o iframe non trovato.");
      return;
    }

    overlay.classList.add("active");
    document.body.style.overflow = "hidden";

    loadIframeIfNeeded();
    sendPendingQuestion();

    if (typeof gtag !== "undefined") {
      gtag("event", "configurator_open", {
        event_category: "engagement",
        event_label: triggeredByQuickQuestion
          ? "quick_question"
          : "manual_open",
      });
    }
  };

  window.openNabeConfigurator = function openNabeConfigurator() {
    openConfiguratorOverlay(false);
  };

  window.openNabeConfiguratorWithQuestion = function openNabeConfiguratorWithQuestion(
    question,
  ) {
    currentQuestion = question;
    openConfiguratorOverlay(true);
  };

  window.closeNabeConfigurator = function closeNabeConfigurator() {
    const overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.remove("active");
    document.body.style.overflow = "";
  };
const CONFIGURATOR_ORIGIN = "https://configuratore-ui.vercel.app";
 window.addEventListener('message', function (event) {
   
    if (event.origin !== CONFIGURATOR_ORIGIN) return;

    if (event.data?.type === 'close-configurator') {
      window.closeNabeConfigurator()
    }
  });




  const handleWidgetScroll = () => {
    const widgets = document.querySelectorAll(".configurator-library");
    if (window.innerWidth > 768) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDelta = scrollTop - lastScrollTop;

    widgets.forEach((widget) => {
      if (scrollDelta > 0 && scrollTop > 50) {
        widget.classList.add("hidden");
      } else if (scrollDelta < -50) {
        widget.classList.remove("hidden");
      }
    });

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  };

  const throttle = (func, wait) => {
    let timeout;
    return function throttled(...args) {
      if (!timeout) {
        timeout = setTimeout(() => {
          func.apply(this, args);
          timeout = null;
        }, wait);
      }
    };
  };

  window.addEventListener("scroll", throttle(handleWidgetScroll, 50));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      window.closeNabeConfigurator();
    }
  });

  const overlay = getOverlay();
  if (overlay) {
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) {
        window.closeNabeConfigurator();
      }
    });
  }

  // ============================================================
  // GESTIONE MESSAGGI DAL CONFIGURATORE
  // - add-to-cart: aggiunta prodotti al carrello Shopify
  // ============================================================
  window.addEventListener("message", (event) => {
    const iframe = getIframe();
    if (!iframe || event.source !== iframe.contentWindow) return;

    // Il configuratore segnala che è pronto
    if (event.data.type === "NABE_CHAT_READY") {
      isChatReady = true;
      sendPendingQuestion();
      console.log("[Nabè configuratore] Configuratore pronto");
      return;
    }

    if (event.data.type === "add-to-cart") {
      const { data } = event.data;
      const { items } = data;

      // ID univoco per questa configurazione (raggruppamento nel carrello)
      // const configId = "config_" + Date.now();

      // Codice configurazione supabase da configuratore
      const configId =
  data.configurationGuid ||
  data.configurationId ||
  ("config_" + Date.now());

      const itemsToAdd = items
        .filter(
          (item) =>
            item.quantity > item.ownedQuantity &&
            item.meta &&
            item.meta.variantId,
        )
        .map((item) => {
          return {
            id: item.meta.variantId,
            quantity: item.quantity - item.ownedQuantity,
            properties: {
              "_nabe_config": "libreria",
              "_nabe_config_id": configId,
              "_nabe_config_label": "Configurazione Libreria",
              "_nabe_configuration_url": data.configurationUrl || "",
            },
          };
        });

      if (itemsToAdd.length === 0) return;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: itemsToAdd }),
      })
        .then((response) => response.json())
        .then((result) => {
          console.log("[Nabè configuratore] Aggiunto al carrello:", result);
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("[Nabè configuratore] Errore add to cart:", error);
        });
    }
  });

  const handle = document.getElementById("nabeConfiguratorBtnOpen");
  if (handle) {
    handle.addEventListener("click", () => {
      window.openNabeConfigurator();
    });
  }

  // ============================================================
  // AUTO-OPEN DA LINK CON ?config=UUID
  // Se l'utente arriva da un link tipo:
  // /products/libreria-evolutiva-evergrow?config=cda2837f-...
  // apre il configuratore e carica la configurazione salvata
  // ============================================================
  const urlParams = new URLSearchParams(window.location.search);

  // ============================================================
  // AUTO-OPEN DA LINK NEL MENÙ (?openConfigurator=1)
  // ============================================================
  if (urlParams.get("openConfigurator") === "1") {
    // Aspetta che il DOM sia pronto, poi apri
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => window.openNabeConfigurator());
    } else {
      window.openNabeConfigurator();
    }

    // Pulisce la URL così se l'utente ricarica non si riapre
    if (window.history && window.history.replaceState) {
      urlParams.delete("openConfigurator");
      const cleanUrl =
        window.location.pathname +
        (urlParams.toString() ? "?" + urlParams.toString() : "") +
        window.location.hash;
      window.history.replaceState({}, "", cleanUrl);
    }
  }

  const savedConfigId = urlParams.get("config");

  if (savedConfigId) {
    console.log("[Nabè configuratore] Config trovata nella URL:", savedConfigId);

    // Carica l'iframe passando il config ID direttamente nella URL
    loadIframeWithConfig(savedConfigId);

    // Apri l'overlay
    const overlayEl = getOverlay();
    if (overlayEl) {
      overlayEl.classList.add("active");
      document.body.style.overflow = "hidden";
    }

    if (typeof gtag !== "undefined") {
      gtag("event", "configurator_open", {
        event_category: "engagement",
        event_label: "shared_config_link",
      });
    }
  }
})();